import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
};
const DefaultColor = "#004ab5";
function BCBC({
  size = 16,
  color = DefaultColor
}: Props): JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color}><path  d="M9.362 5.845a6.566 6.566 0 108.062 9.32l-5.746-3.176 2.331-6.139a6.57 6.57 0 00-4.647-.005m.41 1.18a5.32 5.32 0 013.763.004L11.647 12l4.653 2.573a5.317 5.317 0 11-6.529-7.547m2.201-3.29a8.3 8.3 0 012.61.533L11.647 12l7.238 4a8.272 8.272 0 11-6.912-12.266m5.647 2.86q.298 0 .552.07.75.207 1.012.931.162.441.071.864a1.54 1.54 0 01-.39.758 1.68 1.68 0 011.013.256q.432.273.636.834.288.794-.175 1.451-.459.646-1.641 1.076l-3.123 1.137-2.198-6.04 2.95-1.074q.725-.263 1.293-.264m-.457 1.249q-.27 0-.625.13l-1.39.505.518 1.424 1.39-.506q.518-.187.718-.466.204-.279.073-.633-.127-.353-.459-.429a1 1 0 00-.226-.025m1.171 2.341q-.284.004-.666.143l-1.63.593.543 1.493 1.63-.594q.552-.2.762-.482.218-.284.081-.665-.18-.492-.72-.488" /></Svg>;
}
BCBC.DefaultColor = DefaultColor;
export default BCBC;